import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type TVacantionSelectType = { key: string | number; type?: string };

const initialState: TVacantionSelectType = { key: '0' };

export const selectedVacationSlice = createSlice({
  name: 'selectedVacation',
  initialState,
  reducers: {
    selectedVacation(state, { payload }: PayloadAction<TVacantionSelectType>) {
      return { ...state, ...payload };
    },
  },
});

const selectedVacation = (state: RootState) => state.entities.vacations;
const getSelectedVacation = createSelector(selectedVacation, state => state);

export const selectors = { getSelectedVacation };
export const actions = selectedVacationSlice.actions;
export const reducer = selectedVacationSlice.reducer;
